import { RlFile } from "../../rl-common/file/shared/rl-file";
import { ServerEntity } from "../../rl-common/shared/shared/interfaces/server-entity";

export class Assignment extends ServerEntity{
    thumbnail? : string;
    title : string;
    description : string;
    file : RlFile;
    dueDate? : Date;
    citationId? : string;
    section? : number;
    status? : any;//'PUBLISH' | 'DRAFET';
    lmsAssignmentId : string;
    lmsAssignmentMaxScore : number;
    statistics : {total : number, didntSubmit : number, needToGrade : number, graded : number, avg : number, low : number, high : number, median : number};


    listName : string;
    sectionName : string;
    licenseType : string;
    sanitizeFile : boolean;
    owner: boolean;
}
